import { useState } from 'react';

import { BatchPaymentsActivityProps, BatchPaymentsActivityStep } from './types';

export const useBatchPaymentsActivityStep = ({
  onFirstStepBack,
}: {
  onFirstStepBack: BatchPaymentsActivityProps['onBack'];
}) => {
  const [currentStep, goToStep] = useState<BatchPaymentsActivityStep>('PAYMENT_INTENTS_TABLE');

  const goToPreviousStep = () => {
    if (currentStep === 'PAYMENT_INTENTS_TABLE' || currentStep === 'FIRST_CREATE_FUNDING_SOURCE') {
      onFirstStepBack();
    } else if (currentStep !== 'PAYMENT_SCHEDULED') {
      goToStep('PAYMENT_INTENTS_TABLE');
    }
  };

  return { currentStep, goToStep, goToPreviousStep };
};
